export default "__VITE_ASSET__CBXEzzEB__"